import { render, staticRenderFns } from "./DispensationFormDetailsEscalated.vue?vue&type=template&id=7cb118c4&scoped=true&"
import script from "./DispensationFormDetailsEscalated.vue?vue&type=script&lang=js&"
export * from "./DispensationFormDetailsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./DispensationFormDetailsEscalated.vue?vue&type=style&index=0&id=7cb118c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb118c4",
  null
  
)

export default component.exports